<button
    hisImage="information"
    type="button"
    class="icon"
    [title]="resolvedTitle()"
    (click)="toggle()">
    @if (linkTitle()) {
        <span>{{ resolvedLinkTitle() }}</span>
    }
</button>